import React from 'react';
import StyledDisclaimer from './StyledDisclaimer';
import { TermsLink } from './TermsLink';
import IpidLink from './IPIDLink';

type Props = {
  disclaimer?: null | string;
  ipidUrl?: null | string;
};

export const Disclaimer = ({ disclaimer = null, ipidUrl = null }: Props) => (
  <StyledDisclaimer>
    <p>
      {disclaimer && <>{disclaimer}</>}
      <> <TermsLink/></>
      {ipidUrl && (<> | <IpidLink url={ipidUrl} /></>)}
    </p>
  </StyledDisclaimer>
);
